export default [
  {
    path: 'pi',
    name: 'Pi',
    component: () => import(/* webpackChunkName: "Pi" */ '@/views/Pi.vue')
  },
  {
    path: 'certified',
    name: 'Certified',
    component: () => import(/* webpackChunkName: "Certified" */ '@/views/Certified.vue')
  },
  {
    path: 'excellence',
    name: 'Excellence',
    component: () => import(/* webpackChunkName: "Excellence" */ '@/views/Excellence.vue')
  },
  {
    path: 'kart',
    name: 'Kart',
    component: () => import(/* webpackChunkName: "Kart" */ '@/views/Kart.vue')
  },
  {
    path: '',
    name: 'Base',
    component: () => import(/* webpackChunkName: "Base" */ '@/views/Base.vue')
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue')
  }
]
